import { TestSuite } from './TestSuite';

export default TestSuite;
